import React from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { lookupConfig } from '../../views/Lookups/lookupConfig';
import {Icon, Loader, Menu} from 'semantic-ui-react';


axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orgUnitHierarchy: [],
            activeRole: this.props.activeRole,
            visible: false,
            showStudents:false,
            showExternalStudents: false,
            showNonCyclePrograms: false,
            showThirdCycle:false,
            showDocument: false,
            showExams: false,
            showStudyProgram: false,
            showEmployees: false,
            showLookups: false,
            showProperty: false,
            showHR: false,
            showReports: false,
            showCommittee: false,
            showRecognition: false
        };
        this.props = props;
    }

    handleButtonClick = () => this.setState({ visible: !this.state.visible })
    handleSidebarHide = () => this.setState({ visible: true })
    componentDidMount() {
        //     axios.get('/organizational-units/hierarchy')
        //   .then(response => {
        //       this.setState({ orgUnitHierarchy: response.data });
        //   }).catch(error => {
        //       console.error('Failed to fetch organizational unit hieriarchy');
        //   });
        // axios.get('/user/current')
        //     .then(response => {
        //         const activeRole = response.data;
        //         this.setState({ activeRole });
        //     }).catch(error => {
        //     // TODO amel: error handling
        //     console.error('Failed to fetch active userrole');
        // });
        // axios.get('/countries/access')
        //     .then(response => {
        //         this.setState({ canAccessLKP: response.data });
        //     }).catch(error => {
        //     console.error('Failed to fetch security access');
        // });
        // axios.get('/degree/access')
        //     .then(response => {
        //         this.setState({ canAccessDegrees: response.data });
        //     }).catch(error => {
        //     console.error('Failed to fetch security access');
        // });
        // axios.get('/organizational-units/access')
        //     .then(response => {
        //         this.setState({ canAccessOrgUnits: response.data });
        //     }).catch(error => {
        //     console.error('Failed to fetch security access');
        // });
        // axios.get('/code branchs/access')
        //     .then(response => {
        //         this.setState({ canAccessCertificate: response.data });
        //     }).catch(error => {
        //     console.error('Failed to fetch security access');
        // });
    }
    render() {
        const { visible } = this.state;
        const activeRole = localStorage.getItem('activeRole') || ' ';
        // const orgUnitId = this.state.orgUnitHierarchy.length > 0 ? this.state.orgUnitHierarchy[0][0] : null;
        // const rootOrgUnitUrl = '/univerzitet/' + (this.state.orgUnitHierarchy.length > 0 ? this.state.orgUnitHierarchy[0][0] : '#');
        return (

            <div className={window.location.href.includes('dev1.eunsa.ba') ? "sidebar dev" : "sidebar prod"}
                 style={{
                msOverflowStyle: 'none',
                scrollbarWidth: 'none'  }}>
                <Menu
                    animation='push'
                    inverted
                    style={{
                        backgroundColor: window.location.href.includes('dev1.eunsa.ba') ? '#24826E' : '#263238',
                        paddingBottom: '30px'
                    }}
                    vertical
                    stackable
                    onHide={this.handleSidebarHide}
                    visible={visible}
                    size={'large'}
                >
                        {!window.$locale ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                            <div>

                        {(activeRole.substr(0,8) === 'Student:' || activeRole.substr(0, 11) === 'Diplomirani' || activeRole.substr(0, 7) === 'Ispisan')   &&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>
                            <FormattedMessage id="route.personalInfo" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px'} }>
                                    <Menu.Header> <Icon name='user' /> {<FormattedMessage id="sidebar.personalInfo" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showStudents:!this.state.showStudents})} ><Icon name='student' /> {<FormattedMessage id="sidebar.study" />}
                                    <Icon  name={this.state.showStudents ? 'dropdown' : 'caret left'} size='small'  style={{float:'right'}} /> </Menu.Header>
                                { this.state.showStudents &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <FormattedMessage id="route.gradesOverview" >{
                                        (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                             content={<FormattedMessage id="sidebar.gradesOverview" />}
                                        />)}</FormattedMessage>
                                    <FormattedMessage id="route.coursesOverview" >{
                                        (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                             content={<FormattedMessage id="sidebar.coursesOverview" />}
                                        />)}</FormattedMessage>
                                    {activeRole.substr(0,8) === 'Student:' && <FormattedMessage id="route.optionalCourses" >{
                                    (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                    content={<FormattedMessage id="sidebar.optional" />}
                                    />)}</FormattedMessage>}

                                    { activeRole.substr(0,8) === 'Student:' && <FormattedMessage id="route.currentSemesterCourses" >{
                                        (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                             content={<FormattedMessage id="sidebar.currentSemesterCourses" />}
                                        />)}</FormattedMessage>}
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showExams:!this.state.showExams})} ><Icon name='book' />  {<FormattedMessage id="sidebar.exams" />}
                                    <Icon  name={this.state.showExams ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showExams &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    {activeRole.substr(0,8) === 'Student:' && <FormattedMessage id="route.registerExams" >{
                                        (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                             content={<FormattedMessage id="sidebar.register" />}
                                        />)}</FormattedMessage>}
                                    <FormattedMessage id="route.registeredExams" >{
                                        (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                             content={<FormattedMessage id="sidebar.registeredExams" />}
                                        />)}</FormattedMessage>
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            {activeRole.substr(0,8) === 'Student:' && <Menu.Item
                                as={NavLink}
                                to='/ankete'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='question circle' /> <FormattedMessage id="poll.polls" /> </Menu.Header>
                            </Menu.Item>}
                            <FormattedMessage id="route.requests" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                    <Menu.Header><Icon name='file pdf' /> {<FormattedMessage id="sidebar.documents" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                            {activeRole.substr(0,8) === 'Student:' && <FormattedMessage id="route.academicStaff" >{
                                (msg) => ( <Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                    <Menu.Header><Icon name='group' />  {<FormattedMessage id="common.academicStaff" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>}
                            {activeRole.substr(0,8) === 'Student:' && <FormattedMessage id="route.comments" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                    <Menu.Header><Icon name='envelope' /> {<FormattedMessage id="sidebar.comment" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>}
                            {activeRole.substr(0,8) === 'Student:' && <Menu.Item
                                as='a'
                                href='https://international.unsa.ba/'
                                target='_blank'
                                rel='noopener noreferrer'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='globe' /> Erasmus+ </Menu.Header>
                            </Menu.Item>}
                            <FormattedMessage id="route.contact" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                    <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                            {/*<FormattedMessage id="route.faq" >{*/}
                            {/*    (msg) => (<Menu.Item*/}
                            {/*        as={NavLink}*/}
                            {/*        exact to={msg}*/}
                            {/*        style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*        <Menu.Header><Icon name='question' />  FAQ  </Menu.Header>*/}
                            {/*    </Menu.Item>)}</FormattedMessage>*/}
                            {/* {activeRole.substr(0,8) === 'Student:' && <Menu.Item */}
                            {/*     as={NavLink} */}
                            {/*     to='/stipendije' */}
                            {/*     style={ {paddingBottom:'6px', paddingRight:'35px'} }> */}
                            {/*     <Menu.Header><Icon name='graduation cap' /> <FormattedMessage id="scholarship.scholarship" /> </Menu.Header> */}
                            {/* </Menu.Item>} */}


                        </div>
                        }
                        {activeRole.substr(0,13) === 'Administrator' &&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>


                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showStudents:!this.state.showStudents})} ><Icon name='group' />  Studenti <Icon  name={this.state.showStudents ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showStudents &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}  exact to='/filtriranje-studenata'
                                               content='Informacije o studentu'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/diplomirani-studenti'
                                               content='Diplomirani studenti'
                                    />
                                    <Menu.Item as={NavLink}   to='/studenti/upis-na-predmet'
                                               content='Upis na predmet'
                                    />
                                    <Menu.Item as={NavLink}  to='/studenti/prijava-ispita'
                                               content='Prijava ispita'
                                    />
                                    <Menu.Item as={NavLink}  to='/studenti/unos-ocjena'
                                               content='Unos ocjena'
                                    />

                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as="a" style={{
                                paddingBottom: '6px',
                                paddingRight: '35px'
                            }}>
                                <Menu.Header
                                    onClick={() => this.setState({ showExternalStudents: !this.state.showExternalStudents })}><Icon
                                    name="globe"/> <FormattedMessage id={"sidebar.foreignStudents"}/>
                                    <Icon
                                        name={this.state.showExternalStudents ? 'dropdown' : 'caret left'}
                                        size="small" style={{ float: 'right' }}/>
                                </Menu.Header>
                                {this.state.showExternalStudents &&
                                    <Menu.Menu style={{ marginLeft: '7px' }}>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/dolazne-mobilnosti/registracijski-linkovi"
                                            content={<FormattedMessage id={"sidebar.registrationLinks"}/>}
                                        />
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/dolazne-mobilnosti"
                                            content={<FormattedMessage id={"sidebar.searchForeignStudents"}/>}
                                        />
                                        {/* <Menu.Item */}
                                        {/*     as={NavLink} */}
                                        {/*     exact to="/dolazne-mobilnosti/kreiranje" */}
                                        {/*     content={<FormattedMessage id={"sidebar.createForeignStudents"}/>} */}
                                        {/* /> */}
                                    </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as="a" style={{
                                paddingBottom: '6px',
                                paddingRight: '35px'
                            }}>
                                <Menu.Header
                                    onClick={() => this.setState({ showNonCyclePrograms: !this.state.showNonCyclePrograms })}><Icon
                                    name="code branch"/> <FormattedMessage id={"sidebar.nonCycleProgram"}/>
                                    <Icon
                                        name={this.state.showNonCyclePrograms ? 'dropdown' : 'caret left'}
                                        size="small" style={{ float: 'right' }}/>
                                </Menu.Header>
                                {this.state.showNonCyclePrograms &&
                                    <Menu.Menu style={{ marginLeft: '7px' }}>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/neciklicni-studij/programi"
                                            content={<FormattedMessage id={"sidebar.nonCyclePrograms"}/>}
                                        />
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/neciklicni-studij"
                                            content={<FormattedMessage id={"sidebar.nonCycleStudents"}/>}
                                        />
                                        {/* <Menu.Item */}
                                        {/*     as={NavLink} */}
                                        {/*     exact to="/neciklicni-studij/kreiranje" */}
                                        {/*     content={<FormattedMessage id={"sidebar.createNonCycleStudent"}/>} */}
                                        {/* /> */}
                                    </Menu.Menu>
                                }
                            </Menu.Item>
                            {/*<Menu.Item*/}
                            {/*    as={NavLink}*/}
                            {/*    to='/diplomirani-studenti'*/}
                            {/*    style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*    <Menu.Header><Icon name='graduation cap' /> Diplomirani studenti </Menu.Header>*/}
                            {/*</Menu.Item>*/}
                            <Menu.Item
                                as={NavLink}
                                to='/predmeti'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='list' />     Predmeti </Menu.Header>
                            </Menu.Item>
                            <Menu.Item as={NavLink} to='/razdvajanje-predmeta' style={{paddingBottom: '6px', paddingRight: '35px'}}>
                                <Menu.Header><Icon name='sitemap' /> Razdvajanje predmeta</Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to="/hr-predmeti"
                                style={{
                                    paddingBottom: '6px',
                                    paddingRight: '35px'
                                }}>
                                <Menu.Header><Icon name="list alternate outline"/> HR - predmeti</Menu.Header>
                            </Menu.Item>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showExams:!this.state.showExams})} ><Icon name='book' />  Ispiti <Icon  name={this.state.showExams ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showExams &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}   to='/kreiranje-ispita'
                                               content='Kreiranje ispita'
                                    />
                                    {/*<Menu.Item as={NavLink}  to='/izmjena-datuma-ocjene'*/}
                                    {/*           content='Izmjena datuma ocjene'*/}
                                    {/*/>*/}
                                    {/*<Menu.Item as={NavLink}  to='/brisanje-ispita'*/}
                                    {/*           content='Brisanje ispita'*/}
                                    {/*/>*/}
                                </Menu.Menu>
                                }
                            </Menu.Item>



                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showStudyProgram:!this.state.showStudyProgram})} ><Icon name='list' />  Studijski programi <Icon  name={this.state.showStudyProgram ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showStudyProgram &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}  to='/osnovni-studijski-programi'
                                               content='Osnovni studijski programi'
                                    />
                                    <Menu.Item as={NavLink}  to='/kreiranje-implementacije-smjera'
                                               content={'Kreiranje implementacije'}
                                    />
                                    <Menu.Item as={NavLink}  to='/povezivanje-implementacija-smjera'
                                               content={'Povezivanje implementacija'}
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showTransfer:!this.state.showTransfer})} ><Icon name='arrows alternate horizontal' /> Prebacivanje <Icon  name={this.state.showTransfer ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showTransfer &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}   to='/prebacivanje-podataka'
                                               content='Semestri/ocjene'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showDocument:!this.state.showDocument})} ><Icon name='file pdf' />  Dokumenti <Icon  name={this.state.showDocument ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showDocument &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}   to='/štampanje-diploma'
                                               content='Štampanje diploma'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/pristupni-podaci'
                                               content='Pristupni podaci'
                                    />
                                    <Menu.Item as={NavLink}  to='/konfiguracije'
                                               content='Konfiguracije dokumenata'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/nastavno-osoblje'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='group' />  Nastavno osoblje </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/semestri'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='calendar' /> Semestri </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/online-upis'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='student' /> Online upis </Menu.Header>
                            </Menu.Item>
                            {/*<Menu.Item*/}
                            {/*    as={NavLink}*/}
                            {/*    to='/obavjestenja'*/}
                            {/*    style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*    <Menu.Header><Icon name='bell' /> Obavještenja </Menu.Header>*/}
                            {/*</Menu.Item>*/}
                            <Menu.Item
                                as={NavLink}
                                to='/ankete'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='question circle' /> <FormattedMessage id="poll.polls" />  </Menu.Header>
                            </Menu.Item>
                            {/*<Menu.Item*/}
                                {/*as={NavLink}*/}
                                {/*exact to='/organizacione-jedinice'*/}
                                {/*style={ {paddingBottom:'6px'} } >*/}
                                {/*<Menu.Header><Icon name='university' /> Organizacione jedinice </Menu.Header>*/}
                            {/*</Menu.Item>*/}
                            {/*<Menu.Item  as={NavLink}*/}
                            {/*            exact to='/izvještaji' style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*    <Menu.Header><Icon name='chart line' /> Izvještaji </Menu.Header>*/}
                            {/*</Menu.Item>*/}
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showReports:!this.state.showReports})} ><Icon name='chart line' />  Izvještaji <Icon  name={this.state.showReports ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showReports &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}  exact to='/izvještaji'
                                               content='OJ'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/izvještaji-hr'
                                               content='HR'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to="/obavjestenja"
                                style={{
                                    paddingBottom: '6px',
                                    paddingRight: '35px'
                                }}>
                                <Menu.Header><Icon name="bullhorn"/> Obavještenja </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/šifrarnici'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                <Menu.Header><Icon name='database' /> Šifrarnici </Menu.Header>
                            </Menu.Item>
                            {/* <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }> */}
                            {/*     <Menu.Header   onClick= {()=>this.setState({showLookups:!this.state.showLookups})} ><Icon name='database' />  Šifrarnici <Icon  name={this.state.showLookups ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header> */}
                            {/*     { this.state.showLookups && */}
                            {/*     <Menu.Menu style={ {marginLeft:'7px'} } > */}

                            {/*             <Menu.Item as={NavLink}  to={'/šifrarnici'} content={'Šifrarnici'}/> */}

                            {/*     </Menu.Menu> */}
                            {/*     } */}
                            {/* </Menu.Item> */}
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                            <Menu.Header   onClick= {()=>this.setState({showProperty:!this.state.showProperty})} ><Icon name='building' />  Imovina <Icon  name={this.state.showProperty ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}}/></Menu.Header>
                            { this.state.showProperty &&
                            <Menu.Menu style={ {marginLeft:'7px'} } >
                                <Menu.Item as={NavLink}   to='/imovina/nepokretna-imovina'
                                           content='Nepokretna imovina'
                                />
                                {/*<Menu.Item as={NavLink}  to='/imovina/sredstva'*/}
                                {/*           content='Sredstva'*/}
                                {/*/>*/}
                                {/*<Menu.Item as={NavLink}  to='/imovina/prostorije'*/}
                                {/*           content='Prostorije'*/}
                                {/*/>*/}
                                <Menu.Item as={NavLink}  to='/imovina/zakupci'
                                           content='Zakupci'
                                />
                                <Menu.Item as={NavLink}  to='/imovina/zakupi'
                                           content='Zakupi'
                                />
                                <Menu.Item as={NavLink}   to='/imovina/vozila'
                                           content='Vozila'
                                />
                            </Menu.Menu>
                            }
                        </Menu.Item>

                            {/*<Menu.Item*/}
                            {/*    as={NavLink}*/}
                            {/*    to='/faq'*/}
                            {/*    style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*    <Menu.Header><Icon name='question' /> FAQ </Menu.Header>*/}
                            {/*</Menu.Item>*/}

                            <Menu.Item
                                as={NavLink}
                                exact to="/statistika"
                                style={{
                                    paddingBottom: '6px',
                                    paddingRight: '35px'
                                }}>
                                <Menu.Header><Icon name="pie chart"/> Statistika </Menu.Header>
                            </Menu.Item>

                            <Menu.Item
                                as={NavLink}
                                to="/administratori"
                                style={{
                                    paddingBottom: '6px',
                                    paddingRight: '35px'
                                }}>
                                <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                            </Menu.Item>

                        </div>
                        }

                        {activeRole.substr(0,4) === 'AIDA' &&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>

                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showStudents:!this.state.showStudents})} ><Icon name='group' />  Studenti <Icon  name={this.state.showStudents ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showStudents &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}  exact to='/filtriranje-studenata'
                                               content='Informacije o studentu'
     n                               />
                                    <Menu.Item as={NavLink}  exact to='/diplomirani-studenti'
                                               content='Diplomirani studenti'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as="a" style={{
                                paddingBottom: '6px',
                                paddingRight: '35px'
                            }}>
                                <Menu.Header
                                    onClick={() => this.setState({ showExternalStudents: !this.state.showExternalStudents })}><Icon
                                    name="globe"/> <FormattedMessage id={"sidebar.foreignStudents"}/>
                                    <Icon
                                        name={this.state.showExternalStudents ? 'dropdown' : 'caret left'}
                                        size="small" style={{ float: 'right' }}/>
                                </Menu.Header>
                                {this.state.showExternalStudents &&
                                    <Menu.Menu style={{ marginLeft: '7px' }}>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/dolazne-mobilnosti/registracijski-linkovi"
                                            content={<FormattedMessage id={"sidebar.registrationLinks"}/>}
                                        />
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/dolazne-mobilnosti"
                                            content={<FormattedMessage id={"sidebar.searchForeignStudents"}/>}
                                        />
                                        {/* <Menu.Item */}
                                        {/*     as={NavLink} */}
                                        {/*     exact to="/dolazne-mobilnosti/kreiranje" */}
                                        {/*     content={<FormattedMessage id={"sidebar.createForeignStudents"}/>} */}
                                        {/* /> */}
                                    </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as="a" style={{
                                paddingBottom: '6px',
                                paddingRight: '35px'
                            }}>
                                <Menu.Header
                                    onClick={() => this.setState({ showNonCyclePrograms: !this.state.showNonCyclePrograms })}><Icon
                                    name="code branch"/> <FormattedMessage id={'sidebar.nonCycleProgram'}/>
                                    <Icon
                                        name={this.state.showNonCyclePrograms ? 'dropdown' : 'caret left'}
                                        size="small" style={{ float: 'right' }}/>
                                </Menu.Header>
                                {this.state.showNonCyclePrograms &&
                                    <Menu.Menu style={{ marginLeft: '7px' }}>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/neciklicni-studij/programi"
                                            content={<FormattedMessage id={'sidebar.nonCyclePrograms'}/>}
                                        />
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/neciklicni-studij"
                                            content={<FormattedMessage id={'sidebar.nonCycleStudents'}/>}
                                        />
                                        {/* <Menu.Item */}
                                        {/*     as={NavLink} */}
                                        {/*     exact to="/neciklicni-studij/kreiranje" */}
                                        {/*     content={<FormattedMessage id={"sidebar.createNonCycleStudent"}/>} */}
                                        {/* /> */}
                                    </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to='/predmeti'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='list' />     Predmeti </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to="/hr-predmeti"
                                style={{
                                    paddingBottom: '6px',
                                    paddingRight: '35px'
                                }}>
                                <Menu.Header><Icon name="list alternate outline"/> HR - predmeti</Menu.Header>
                            </Menu.Item>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showExams:!this.state.showExams})} ><Icon name='book' />  Ispiti <Icon  name={this.state.showExams ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showExams &&
                                    <Menu.Menu style={ {marginLeft:'7px'} } >
                                        <Menu.Item as={NavLink}   to='/kreiranje-ispita'
                                                   content='Kreiranje ispita'
                                        />
                                    </Menu.Menu>
                                }
                            </Menu.Item>

                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showStudyProgram:!this.state.showStudyProgram})} ><Icon name='list' />  Studijski programi <Icon  name={this.state.showStudyProgram ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showStudyProgram &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}  to='/osnovni-studijski-programi'
                                               content='Osnovni studijski programi'
                                    />
                                    <Menu.Item as={NavLink}  to='/kreiranje-implementacije-smjera'
                                               content={'Kreiranje implementacije'}
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>

                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showTransfer:!this.state.showTransfer})} ><Icon name='arrows alternate horizontal' /> Prebacivanje <Icon  name={this.state.showTransfer ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showTransfer &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}   to='/prebacivanje-podataka'
                                               content='Semestri/ocjene'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>

                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showDocument:!this.state.showDocument})} ><Icon name='file pdf' />  Dokumenti <Icon  name={this.state.showDocument ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showDocument &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}   to='/štampanje-diploma'
                                               content='Štampanje diploma'
                                    />
                                    {/*<Menu.Item as={NavLink}  exact to='/pristupni-podaci'*/}
                                    {/*           content='Pristupni podaci'*/}
                                    {/*/>*/}
                                    <Menu.Item as={NavLink}  to='/konfiguracije'
                                               content='Konfiguracije dokumenata'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>


                            <Menu.Item
                                as={NavLink}
                                exact to='/nastavno-osoblje'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='group' />  Nastavno osoblje </Menu.Header>
                            </Menu.Item>

                            <Menu.Item
                                as={NavLink}
                                exact to='/semestri'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='calendar' /> Semestri </Menu.Header>
                            </Menu.Item>

                            {/*<Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*    <Menu.Header   onClick= {()=>this.setState({showLookups:!this.state.showLookups})} ><Icon name='database' />  Šifrarnici <Icon  name={this.state.showLookups ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>*/}
                            {/*    { this.state.showLookups &&*/}
                            {/*    <Menu.Menu style={ {marginLeft:'7px'} } >*/}
                            {/*        {lookupConfig.map((config, index) => (*/}
                            {/*            <Menu.Item as={NavLink}  to={'/šifrarnici/' + config.frontEndPath}*/}
                            {/*                       content={config.tableSimpleName}*/}
                            {/*            />*/}
                            {/*        ))}*/}
                            {/*    </Menu.Menu>*/}
                            {/*    }*/}
                            {/*</Menu.Item>*/}
                            <Menu.Item
                                as={NavLink}
                                to='/ankete'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='question circle' /> <FormattedMessage id="poll.polls" />  </Menu.Header>
                            </Menu.Item>
                            <Menu.Item  as={NavLink}
                                        exact to='/izvještaji' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='chart line' /> Izvještaji </Menu.Header>
                            </Menu.Item>

                            <Menu.Item
                                as={NavLink}
                                to='/obavjestenja'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='bullhorn' /> Obavještenja </Menu.Header>
                            </Menu.Item>

                            {/*<Menu.Item*/}
                            {/*    as={NavLink}*/}
                            {/*    to='/faq'*/}
                            {/*    style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*    <Menu.Header><Icon name='question' /> FAQ </Menu.Header>*/}
                            {/*</Menu.Item>*/}

                            <Menu.Item
                                as={NavLink}
                                to="/administratori"
                                style={{
                                    paddingBottom: '6px',
                                    paddingRight: '35px'
                                }}>
                                <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                            </Menu.Item>

                        </div>
                        }

                        {activeRole.substr(0,7) === 'Support' &&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>

                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showStudents:!this.state.showStudents})} ><Icon name='group' />  Studenti <Icon  name={this.state.showStudents ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showStudents &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}  exact to='/filtriranje-studenata'
                                               content='Informacije o studentu'
                                               n                               />
                                </Menu.Menu>
                                }
                            </Menu.Item>

                            {/*<Menu.Item*/}
                            {/*    as={NavLink}*/}
                            {/*    to='/faq'*/}
                            {/*    style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*    <Menu.Header><Icon name='question' /> FAQ </Menu.Header>*/}
                            {/*</Menu.Item>*/}

                        </div>}

                        {activeRole.substr(0,8) === 'Profesor'&&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>
                            <FormattedMessage id="route.personalInf" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                    <Menu.Header><Icon name='user' /> {<FormattedMessage id="sidebar.personalInfo" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                            <FormattedMessage id="route.filterStudentsForProfessor" >{
                               (msg) => (<Menu.Item
                                   as={NavLink}
                                   exact to={msg}
                                   style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                   <Menu.Header><Icon name='search' /> {<FormattedMessage id="common.students" />} </Menu.Header>
                               </Menu.Item>)}</FormattedMessage>
                            <Menu.Item as="a" style={{
                                paddingBottom: '6px',
                                paddingRight: '35px'
                            }}>
                                <Menu.Header
                                    onClick={() => this.setState({ showExternalStudents: !this.state.showExternalStudents })}><Icon
                                    name="globe"/> Dolazne mobilnosti
                                    <Icon
                                        name={this.state.showExternalStudents ? 'dropdown' : 'caret left'}
                                        size="small" style={{ float: 'right' }}/>
                                </Menu.Header>
                                {this.state.showExternalStudents &&
                                    <Menu.Menu style={{ marginLeft: '7px' }}>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/dolazne-mobilnosti/ocjenjivanje"
                                            content={<FormattedMessage id={"sidebar.grading"}/>}
                                        />
                                        {/* <Menu.Item */}
                                        {/*     as={NavLink} */}
                                        {/*     exact to="/dolazne-mobilnosti" */}
                                        {/*     content={<FormattedMessage id={"sidebar.searchForeignStudents"}/>} */}
                                        {/* /> */}
                                    </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as="a" style={{
                                paddingBottom: '6px',
                                paddingRight: '35px'
                            }}>
                                <Menu.Header
                                    onClick={() => this.setState({ showNonCyclePrograms: !this.state.showNonCyclePrograms })}><Icon
                                    name="code branch"/> <FormattedMessage id={"sidebar.nonCycleProgram"}/>
                                    <Icon
                                        name={this.state.showNonCyclePrograms ? 'dropdown' : 'caret left'}
                                        size="small" style={{ float: 'right' }}/>
                                </Menu.Header>
                                {this.state.showNonCyclePrograms &&
                                    <Menu.Menu style={{ marginLeft: '7px' }}>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/neciklicni-studij/ocjenjivanje"
                                            content={<FormattedMessage id={"sidebar.grading"}/>}
                                        />
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/neciklicni-studij/programi"
                                            content={<FormattedMessage id={"sidebar.nonCycleProgramLead"}/>}
                                        />
                                        {/* <Menu.Item */}
                                        {/*     as={NavLink} */}
                                        {/*     exact to="/neciklicni-studij" */}
                                        {/*     content={<FormattedMessage id={"sidebar.nonCycleStudents"}/>} */}
                                        {/* /> */}
                                    </Menu.Menu>
                                }
                            </Menu.Item>
                            <FormattedMessage id="route.courses" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                    <Menu.Header><Icon name='list' /> {<FormattedMessage id="sidebar.courses" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showExams:!this.state.showExams})} ><Icon name='book' />  {<FormattedMessage id="sidebar.exams" />}
                                    <Icon  name={this.state.showExams ? 'dropdown' : 'caret left'}  size='small' style={{float:'right'}}/></Menu.Header>
                                { this.state.showExams &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <FormattedMessage id="route.upcomingExams" >{
                                        (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                             content={<FormattedMessage id="professorInputGrades.upcomingExams" />}
                                        />)}</FormattedMessage>
                                    <FormattedMessage id="route.active" >{
                                        (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                             content={<FormattedMessage id="sidebar.activeExams" />}
                                        />)}</FormattedMessage>
                                    <FormattedMessage id="route.finalized" >{
                                        (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                             content={<FormattedMessage id="sidebar.finalizedExams" />}
                                        />)}</FormattedMessage>
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            {/*<Menu.Item*/}
                            {/*    as={NavLink}*/}
                            {/*    to='/ankete'*/}
                            {/*    style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*    <Menu.Header><Icon name='question circle' /> Ankete </Menu.Header>*/}
                            {/*</Menu.Item>*/}

                            <FormattedMessage id="route.mentorships" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                    <Menu.Header><Icon name='student' /> {<FormattedMessage id="sidebar.mentorships" />}</Menu.Header>
                                </Menu.Item>)}</FormattedMessage>

                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showProfPoll:!this.state.showProfPoll})} ><Icon name='question circle' />  <FormattedMessage id="poll.polls" />  <Icon  name={this.state.showProfPoll ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showProfPoll &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <FormattedMessage id="route.polls" >{
                                        (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                             content={<FormattedMessage id="poll.results" />}
                                        />)}</FormattedMessage>
                                    <FormattedMessage id="route.access" >{
                                        (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                             content={<FormattedMessage id="poll.access" />}
                                        />)}
                                    </FormattedMessage>
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item
                                as='a'
                                href='https://international.unsa.ba/'
                                target='_blank'
                                rel='noopener noreferrer'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='globe' /> Erasmus+ </Menu.Header>
                            </Menu.Item>
                            <FormattedMessage id="route.comments" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                    <Menu.Header><Icon name='envelope' /> {<FormattedMessage id="sidebar.comment" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                            <FormattedMessage id="route.contact" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                    <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />}</Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                            {/*<FormattedMessage id="route.faq" >{*/}
                            {/*    (msg) => (<Menu.Item*/}
                            {/*        as={NavLink}*/}
                            {/*        exact to={msg}*/}
                            {/*        style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*        <Menu.Header><Icon name='question' />  FAQ  </Menu.Header>*/}
                            {/*    </Menu.Item>)}</FormattedMessage>*/}
                        </div>
                        }
                        {activeRole.substr(0,8) === 'Asistent'&&
                    <div>
                        <Menu.Item
                            as={NavLink}
                            exact to='/'
                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                        >
                            <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                        </Menu.Item>
                        <FormattedMessage id="route.personalInf" >{
                            (msg) => (<Menu.Item
                                as={NavLink}
                                exact to={msg}
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='user' /> {<FormattedMessage id="sidebar.personalInfo" />} </Menu.Header>
                            </Menu.Item>)}</FormattedMessage>
                        {/*<FormattedMessage id="route.filterStudentsForProfessor" >{*/}
                        {/*    (msg) => (<Menu.Item*/}
                        {/*        as={NavLink}*/}
                        {/*        exact to={msg}*/}
                        {/*        style={ {paddingBottom:'6px', paddingRight:'35px'} } >*/}
                        {/*        <Menu.Header><Icon name='search' /> {<FormattedMessage id="common.students" />} </Menu.Header>*/}
                        {/*    </Menu.Item>)}</FormattedMessage>*/}
                        <Menu.Item
                            as={NavLink}
                            to='/spisak-predmeta'
                            style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                            <Menu.Header><Icon name='list' /> <FormattedMessage id="sidebar.courses" /> </Menu.Header>
                        </Menu.Item>

                        <Menu.Item  as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                            <Menu.Header onClick= {()=>this.setState({showExams:!this.state.showExams})}> <Icon name='book' /> <FormattedMessage id="sidebar.exams" /> <Icon  name={this.state.showExams ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                            {this.state.showExams &&
                            <Menu.Menu style={{marginLeft:'7px'}}>
                                <FormattedMessage id="route.upcomingExams" >{
                                    (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                         content={<FormattedMessage id="professorInputGrades.upcomingExams" />}
                                    />)}</FormattedMessage>
                                <FormattedMessage id="route.active" >{
                                    (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                         content={<FormattedMessage id="sidebar.activeExams" />}
                                    />)}</FormattedMessage>
                                <FormattedMessage id="route.finalized" >{
                                    (msg) => (<Menu.Item as={NavLink}  exact to={msg}
                                                         content={<FormattedMessage id="sidebar.finalizedExams" />}
                                    />)}</FormattedMessage>
                            </Menu.Menu>
                            }
                        </Menu.Item>


                        <Menu.Item
                            as={NavLink}
                            to='/ankete'
                            style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                            <Menu.Header><Icon name='question circle' /> <FormattedMessage id="poll.polls" />  </Menu.Header>
                        </Menu.Item>

                        <Menu.Item
                            as='a'
                            href='https://international.unsa.ba/'
                            target='_blank'
                            rel='noopener noreferrer'
                            style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                            <Menu.Header><Icon name='globe' /> Erasmus+ </Menu.Header>
                        </Menu.Item>
                        <FormattedMessage id="route.comments" >{
                            (msg) => (<Menu.Item
                                as={NavLink}
                                exact to={msg}
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='envelope' /> {<FormattedMessage id="sidebar.comment" />} </Menu.Header>
                            </Menu.Item>)}</FormattedMessage>
                        <FormattedMessage id="route.contact" >{
                            (msg) => (<Menu.Item
                                as={NavLink}
                                exact to={msg}
                                style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />}</Menu.Header>
                            </Menu.Item>)}</FormattedMessage>
                        {/*<FormattedMessage id="route.faq" >{*/}
                        {/*    (msg) => (<Menu.Item*/}
                        {/*        as={NavLink}*/}
                        {/*        exact to={msg}*/}
                        {/*        style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                        {/*        <Menu.Header><Icon name='question' />  FAQ  </Menu.Header>*/}
                        {/*    </Menu.Item>)}</FormattedMessage>*/}
                    </div>
                    }
                        {activeRole.substr(0,14) === 'QA admin - OJ:'&&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>

                            <Menu.Item
                                as={NavLink}
                                to='/ankete'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='question circle' /> <FormattedMessage id="poll.polls" />  </Menu.Header>
                            </Menu.Item>

                            {/*<Menu.Item*/}
                            {/*    as={NavLink}*/}
                            {/*    to='/izvještaji-ankete'*/}
                            {/*    style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*    <Menu.Header><Icon name='newspaper' /> Izvještaji </Menu.Header>*/}
                            {/*</Menu.Item>*/}

                            <FormattedMessage id="route.comments" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                    <Menu.Header><Icon name='envelope' /> {<FormattedMessage id="sidebar.comment" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                            <FormattedMessage id="route.contact" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                    <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />}</Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                            <Menu.Item
                                as={NavLink}
                                to="/administratori"
                                style={{
                                    paddingBottom: '6px',
                                    paddingRight: '35px'
                                }}>
                                <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                            </Menu.Item>
                        </div>
                        }

                                {activeRole.startsWith('QA admin:') &&
                                    <div>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                                        </Menu.Item>

                                        <Menu.Item
                                            as={NavLink}
                                            to='/ankete'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                            <Menu.Header><Icon name='question circle' /> <FormattedMessage id="poll.polls" />  </Menu.Header>
                                        </Menu.Item>

                                        <Menu.Item
                                            as={NavLink}
                                            to='/rezultati'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                            <Menu.Header><Icon name='newspaper' /> Rezultati  </Menu.Header>
                                        </Menu.Item>

                                        <FormattedMessage id="route.comments" >{
                                            (msg) => (<Menu.Item
                                                as={NavLink}
                                                exact to={msg}
                                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                                <Menu.Header><Icon name='envelope' /> {<FormattedMessage id="sidebar.comment" />} </Menu.Header>
                                            </Menu.Item>)}</FormattedMessage>
                                        <FormattedMessage id="route.contact" >{
                                            (msg) => (<Menu.Item
                                                as={NavLink}
                                                exact to={msg}
                                                style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                                <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />}</Menu.Header>
                                            </Menu.Item>)}</FormattedMessage>
                                        <Menu.Item
                                            as={NavLink}
                                            to="/administratori"
                                            style={{
                                                paddingBottom: '6px',
                                                paddingRight: '35px'
                                            }}>
                                            <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                                        </Menu.Item>
                                    </div>
                                }
                        {activeRole.substr(0,7) === 'Imovina'  &&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showProperty:!this.state.showProperty})} ><Icon name='building' />  Imovina <Icon  name={this.state.showProperty ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}}/></Menu.Header>
                                { this.state.showProperty &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}   to='/imovina/nepokretna-imovina'
                                               content='Nepokretna imovina'
                                    />
                                    {/*<Menu.Item as={NavLink}  to='/imovina/prostorije'*/}
                                    {/*           content='Prostorije'*/}
                                    {/*/>*/}
                                    {/*<Menu.Item as={NavLink}  to='/imovina/sredstva'*/}
                                    {/*           content='Sredstva'*/}
                                    {/*/>*/}
                                    <Menu.Item as={NavLink}   to='/imovina/vozila'
                                               content='Vozila'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showLeases:!this.state.showLeases})} ><Icon name='file alternate outline' />  Zakup <Icon  name={this.state.showLeases ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}}/></Menu.Header>
                                { this.state.showLeases &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}   to='/imovina/zakupci'
                                               content='Zakupci'
                                    />
                                    <Menu.Item as={NavLink}  to='/imovina/zakupi'
                                               content='Zakupi'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            {(activeRole === 'Imovina super admin' || activeRole === 'Imovina admin') &&
                                <Menu.Item
                                    as={NavLink}
                                    to="/administratori"
                                    style={{
                                        paddingBottom: '6px',
                                        paddingRight: '35px'
                                    }}>
                                    <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                                </Menu.Item>
                            }
                            <FormattedMessage id="route.comments">{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={{
                                        paddingBottom: '6px',
                                        paddingRight: '35px'
                                    }}>
                                    <Menu.Header><Icon name="envelope"/> {<FormattedMessage id="sidebar.comment"/>}
                                    </Menu.Header>
                                </Menu.Item>)}
                            </FormattedMessage>
                            <FormattedMessage id="route.contact">{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={{
                                        paddingBottom: '6px',
                                        paddingRight: '35px'
                                    }}>
                                    <Menu.Header><Icon name="info circle"/> {<FormattedMessage id="sidebar.contact"/>}
                                    </Menu.Header>
                                </Menu.Item>)}
                            </FormattedMessage>
                        </div>
                        }
                        {activeRole.substr(0,10) === 'Studentska' &&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showStudents:!this.state.showStudents})} ><Icon name='group' />  Studenti <Icon  name={this.state.showStudents ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showStudents &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}  exact to='/filtriranje-studenata'
                                               content='Informacije o studentu'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/spisak-studenata'
                                               content='Spisak studenata'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/unos-studenta'
                                               content='Unos studenta'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/upis-studenata'
                                               content='Upis na studijski program'
                                    />
                                    {/*<Menu.Item as={NavLink}  exact to='/studentske-grupe'*/}
                                    {/*           content='Studentske grupe'*/}
                                    {/*/>*/}
                                    <Menu.Item as={NavLink}  exact to='/treći-ciklus'
                                               content='Treći ciklus'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/specijalistički-studij'
                                               content='Specijalistički studij'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as="a" style={{
                                paddingBottom: '6px',
                                paddingRight: '35px'
                            }}>
                                <Menu.Header
                                    onClick={() => this.setState({ showExternalStudents: !this.state.showExternalStudents })}><Icon
                                    name="globe"/> <FormattedMessage id={"sidebar.foreignStudents"}/>
                                    <Icon
                                        name={this.state.showExternalStudents ? 'dropdown' : 'caret left'}
                                        size="small" style={{ float: 'right' }}/>
                                </Menu.Header>
                                {this.state.showExternalStudents &&
                                    <Menu.Menu style={{ marginLeft: '7px' }}>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/dolazne-mobilnosti/registracijski-linkovi"
                                            content={<FormattedMessage id={"sidebar.registrationLinks"}/>}
                                        />
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/dolazne-mobilnosti"
                                            content={<FormattedMessage id={"sidebar.searchForeignStudents"}/>}
                                        />
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/dolazne-mobilnosti/kreiranje"
                                            content={<FormattedMessage id={"sidebar.createForeignStudents"}/>}
                                        />
                                    </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item as="a" style={{
                                paddingBottom: '6px',
                                paddingRight: '35px'
                            }}>
                                <Menu.Header
                                    onClick={() => this.setState({ showNonCyclePrograms: !this.state.showNonCyclePrograms })}><Icon
                                    name="code branch"/> <FormattedMessage id={"sidebar.nonCycleProgram"}/>
                                    <Icon
                                        name={this.state.showNonCyclePrograms ? 'dropdown' : 'caret left'}
                                        size="small" style={{ float: 'right' }}/>
                                </Menu.Header>
                                {this.state.showNonCyclePrograms &&
                                    <Menu.Menu style={{ marginLeft: '7px' }}>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/neciklicni-studij/programi"
                                            content={<FormattedMessage id={"sidebar.nonCyclePrograms"}/>}
                                        />
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/neciklicni-studij"
                                            content={<FormattedMessage id={"sidebar.nonCycleStudents"}/>}
                                        />
                                        <Menu.Item
                                            as={NavLink}
                                            exact to="/neciklicni-studij/kreiranje"
                                            content={<FormattedMessage id={"sidebar.createNonCycleStudent"}/>}
                                        />
                                    </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/predmeti'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header><Icon name='edit' /> Predmeti </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/studijski-programi'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header><Icon name='list' /> Studijski programi </Menu.Header>
                            </Menu.Item>

                            <Menu.Item  as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                <Menu.Header onClick= {()=>this.setState({showExams:!this.state.showExams})}> <Icon name='book' /> Ispiti <Icon  name={this.state.showExams ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                {this.state.showExams &&
                                <Menu.Menu style={{marginLeft:'7px'}}>
                                    <Menu.Item as={NavLink}  exact to='/ispitni-rokovi'
                                               content='Ispitni rokovi'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/kreiranje-i-prikaz-ispita-po-predmetima'
                                               content='Kreiranje i prikaz ispita po predmetima'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/kreiranje-i-prikaz-ispita-po-rokovima'
                                               content='Kreiranje i prikaz ispita po ispitnim rokovima'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/ispitne-grupe'
                                               content='Ispitne grupe'
                                    />
                                    <Menu.Item as={NavLink}  to='/komisijski-ispiti'
                                               content='Komisijski ispiti'
                                    /><
                                    Menu.Item as={NavLink} to='/studenti'
                                               content='Poništavanje ocjena'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to='/kolizija'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='random' /> Kolizija </Menu.Header>
                            </Menu.Item>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showCommittee:!this.state.showCommittee})} ><Icon name='exchange' />Ekvivalencija ispita<Icon  name={this.state.showCommittee ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}}/></Menu.Header>
                                { this.state.showCommittee &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}   to='/ekvivalencija-ispita/komisija'
                                               content='Komisija'
                                    />
                                    <Menu.Item as={NavLink}   to='/ekvivalencija-ispita/kreiranje-kandidata'
                                               content='Kreiranje kandidata'
                                    />
                                    <Menu.Item as={NavLink}   to='/ekvivalencija-ispita/prikaz-kandidata'
                                               content='Prikaz kandidata'
                                    />

                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/prelazak-studenata'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header><Icon name='check circle' /> Priznavanje ispita </Menu.Header>
                            </Menu.Item>
                            <Menu.Item  as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header onClick= {()=>this.setState({showDocument:!this.state.showDocument})}> <Icon name='file pdf' /> Dokumenti <Icon  name={this.state.showDocument ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                {this.state.showDocument &&
                                <Menu.Menu style={{marginLeft:'7px'}}>
                                    <Menu.Item as={NavLink}  exact to='/zahtjevi-za-dokumente'
                                               content='Zahtjevi'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/statusne-potvrde-i-prepisi-ocjena'
                                               content='Potvrde i prepisi ocjena'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/uvjerenje-o-završenom-ciklusu'
                                               content='Uvjerenje o završenom ciklusu'
                                    />
                                    <Menu.Item as={NavLink} exact to="/prijave-za-polaganje-ispita"
                                               content="Prijave za ispite"
                                               onClick={() => {
                                                   localStorage.removeItem('examApplicationsByProfessorFilters');
                                               }}
                                    />
                                    <Menu.Item as={NavLink}  exact to='/ispisnice'
                                               content='Ispisnice'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/konfiguracije-dokumenata'
                                               content='Konfiguracije dokumenata'
                                    />
                                </Menu.Menu>}
                            </Menu.Item>

                            {/*<Menu.Item  as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*<Menu.Header onClick= {()=>this.setState({showReports:!this.state.showReports})}> <Icon name='pie chart' /> Izvještaji <Icon  name={this.state.showReports ? 'dropdown' : 'caret left'} style={{float:'right'}} size='small' /></Menu.Header>*/}
                            {/*{this.state.showReports &&*/}
                            {/*<Menu.Menu style={{marginLeft:'7px'}}>*/}
                            {/*<Menu.Item as={NavLink}  exact to='/prosjeci-po-godinama'*/}
                            {/*content='Prosjeci po godinama'*/}
                            {/*/>*/}
                            {/*<Menu.Item as={NavLink}  exact to='/diplomirani-po-ciklusima'*/}
                            {/*content='Diplomirani po ciklusima'*/}
                            {/*/>*/}
                            {/*<Menu.Item as={NavLink}  exact to='/diplomirani-po-ciklusima-i-spolu'*/}
                            {/*content='Diplomirani po ciklusima (M/Ž)'*/}
                            {/*/>*/}
                            {/*<Menu.Item as={NavLink}  exact to='/upisani-po-ciklusima'*/}
                            {/*content='Upisani po ciklusima'*/}
                            {/*/>*/}
                            {/*<Menu.Item as={NavLink}  exact to='/upisani-po-tipu-studiranja'*/}
                            {/*content='Upisani po tipu studiranja'*/}
                            {/*/>*/}
                            {/*<Menu.Item as={NavLink}  exact to='/upisani-po-godinama'*/}
                            {/*content='Upisani po godinama'*/}
                            {/*/>*/}
                            {/*<Menu.Item as={NavLink}  exact to='/upisani-po-općinama'*/}
                            {/*content='Upisani po općinama'*/}
                            {/*/>*/}
                            {/*<Menu.Item as={NavLink}  exact to='/upisani-po-državama'*/}
                            {/*content='Upisani po državama'*/}
                            {/*/>*/}
                            {/*</Menu.Menu>}*/}
                            {/*</Menu.Item>*/}

                            {/*<Menu.Item  as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                                {/*<Menu.Header onClick= {()=>this.setState({showEmployees:!this.state.showEmployees})}> <Icon name='group' /> */}
                                {/*Nastavno osoblje <Icon  name={this.state.showEmployees ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>*/}
                                {/*{this.state.showEmployees &&*/}
                                {/*<Menu.Menu style={{marginLeft:'7px'}}>*/}
                                    {/*<Menu.Item as={NavLink}  exact to='/nastavno-osoblje'*/}
                                               {/*content='Spisak nastavnog osoblja'*/}
                                    {/*/>*/}
                                    {/*/!*<Menu.Item as={NavLink}  exact to='/korisnički-računi'*!/*/}
                                    {/*/!*content='Korisnički računi'*!/*/}
                                {/*</Menu.Menu>}*/}
                            {/*</Menu.Item>*/}
                            <Menu.Item
                                as={NavLink}
                                exact to='/nastavno-osoblje'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='group' />  Nastavno osoblje </Menu.Header>
                            </Menu.Item>
                            <Menu.Item  as={NavLink}
                                        exact to='/izvještaji' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='chart line' /> Izvještaji </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to="/administratori"
                                style={{
                                    paddingBottom: '6px',
                                    paddingRight: '35px'
                                }}>
                                <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/komentari-i-prijedlozi'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='envelope' /> Komentari i prijedlozi </Menu.Header>
                            </Menu.Item>

                            <FormattedMessage id="route.contact" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                    <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                            {/*<Menu.Item*/}
                            {/*    as={NavLink}*/}
                            {/*    exact to='/pitanja-i-odgovori'*/}
                            {/*    style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                            {/*    <Menu.Header><Icon name='question' />  FAQ  </Menu.Header>*/}
                            {/*</Menu.Item>*/}
                        </div>
                        }

                        {activeRole.substr(0,19) === 'Prodekan za nastavu' &&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>
                            <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showStudents:!this.state.showStudents})} ><Icon name='group' />  Studenti <Icon  name={this.state.showStudents ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} /></Menu.Header>
                                { this.state.showStudents &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    <Menu.Item as={NavLink}  exact to='/filtriranje-studenata'
                                               content='Informacije o studentu'
                                    />
                                    <Menu.Item as={NavLink}  exact to='/spisak-studenata'
                                               content='Spisak studenata'
                                    />
                                </Menu.Menu>
                                }
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/predmeti'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header><Icon name='edit' /> Predmeti </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/studijski-programi'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header><Icon name='list' /> Studijski programi </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/nastavno-osoblje'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='group' />  Nastavno osoblje </Menu.Header>
                            </Menu.Item>
                            <Menu.Item  as={NavLink}
                                        exact to='/izvještaji' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='chart line' /> Izvještaji </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                to="/administratori"
                                style={{
                                    paddingBottom: '6px',
                                    paddingRight: '35px'
                                }}>
                                <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/komentari-i-prijedlozi'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='envelope' /> Komentari i prijedlozi </Menu.Header>
                            </Menu.Item>
                            <FormattedMessage id="route.contact" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                    <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                        </div>
                        }

                        {activeRole.substr(0,38) === 'Služba za nastavu i studentska pitanja' &&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/predmeti'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header><Icon name='edit' /> Predmeti </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/osnovni-studijski-programi'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                            <Menu.Header><Icon name='list' /> Studijski programi </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/ispitni-rokovi'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            ><Menu.Header><Icon name='book' /> Ispitni rokovi </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/nastavno-osoblje'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='group' />  Nastavno osoblje </Menu.Header>
                            </Menu.Item>
                            <Menu.Item  as={NavLink}
                                        exact to='/izvještaji' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='chart line' /> Izvještaji </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/komentari-i-prijedlozi'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='envelope' /> Komentari i prijedlozi </Menu.Header>
                            </Menu.Item>
                            <FormattedMessage id="route.contact" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                    <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                        </div>
                        }

                                {activeRole.substr(0,30) === 'Služba za osiguranje kvaliteta' &&
                                    <div>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/predmeti'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header><Icon name='edit' /> Predmeti </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/osnovni-studijski-programi'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header><Icon name='list' /> Studijski programi </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item  as={NavLink}
                                                    exact to='/izvještaji' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                            <Menu.Header><Icon name='chart line' /> Izvještaji </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/komentari-i-prijedlozi'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                            <Menu.Header><Icon name='envelope' /> Komentari i prijedlozi </Menu.Header>
                                        </Menu.Item>
                                        <FormattedMessage id="route.contact" >{
                                            (msg) => (<Menu.Item
                                                as={NavLink}
                                                exact to={msg}
                                                style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                                <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />} </Menu.Header>
                                            </Menu.Item>)}</FormattedMessage>
                                        <Menu.Item
                                            as={NavLink}
                                            to="/administratori"
                                            style={{
                                                paddingBottom: '6px',
                                                paddingRight: '35px'
                                            }}>
                                            <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                                        </Menu.Item>
                                    </div>
                                }
                                {activeRole.substr(0, 30) === 'Služba za međunarodnu saradnju' &&
                                    <div>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/dolazne-mobilnosti'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header><Icon name='globe' /> Dolazne mobilnosti </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/odlazne-mobilnosti'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header><Icon name='sync' /> Odlazne mobilnosti </Menu.Header>
                                        </Menu.Item>
                                        {/* <Menu.Item */}
                                        {/*     as={NavLink} */}
                                        {/*     exact to='/dolazne-mobilnosti/kreiranje' */}
                                        {/*     style={ {paddingBottom:'6px', paddingRight:'35px'} } */}
                                        {/* > */}
                                        {/*     <Menu.Header><Icon name='user plus' /> {<FormattedMessage id="externalStudent.createStudent"/>} </Menu.Header> */}
                                        {/* </Menu.Item> */}
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/dolazne-mobilnosti/registracijski-linkovi'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header><Icon name='linkify' /> {<FormattedMessage id="externalStudent.registrationLinks"/>} </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            to='/obavjestenja'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                            <Menu.Header><Icon name='bullhorn' /> Obavještenja </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            to="/administratori"
                                            style={{
                                                paddingBottom: '6px',
                                                paddingRight: '35px'
                                            }}>
                                            <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/komentari-i-prijedlozi'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                            <Menu.Header><Icon name='envelope' /> Komentari i prijedlozi </Menu.Header>
                                        </Menu.Item>
                                        <FormattedMessage id="route.contact" >{
                                            (msg) => (<Menu.Item
                                                as={NavLink}
                                                exact to={msg}
                                                style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                                <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />} </Menu.Header>
                                            </Menu.Item>)}</FormattedMessage>
                                    </div>
                                }

                                {activeRole.startsWith('Prodekan za međunarodnu') &&
                                    <div>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                            <Menu.Header onClick={() => this.setState({showStudents: !this.state.showStudents})}>
                                                <Icon name='group' /> Studenti
                                                <Icon name={this.state.showStudents ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}} />
                                            </Menu.Header>
                                            {this.state.showStudents &&
                                                <Menu.Menu style={ {marginLeft:'7px'} }>
                                                    <Menu.Item as={NavLink} exact to='/filtriranje-studenata'
                                                               content='Informacije o studentu' />
                                                    <Menu.Item as={NavLink} exact to='/spisak-studenata'
                                                               content='Spisak studenata' />
                                                </Menu.Menu>
                                            }
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/dolazne-mobilnosti'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header><Icon name='globe' /> {<FormattedMessage id="sidebar.foreignStudents"/>} </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/odlazne-mobilnosti'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header><Icon name='sync' /> Odlazne mobilnosti </Menu.Header>
                                        </Menu.Item>
                                        {/* <Menu.Item */}
                                        {/*     as={NavLink} */}
                                        {/*     exact to='/dolazne-mobilnosti/kreiranje' */}
                                        {/*     style={ {paddingBottom:'6px', paddingRight:'35px'} } */}
                                        {/* > */}
                                        {/*     <Menu.Header><Icon name='user plus' /> {<FormattedMessage id="externalStudent.createStudent"/>} </Menu.Header> */}
                                        {/* </Menu.Item> */}
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/dolazne-mobilnosti/registracijski-linkovi'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }
                                        >
                                            <Menu.Header><Icon name='linkify' /> {<FormattedMessage id="externalStudent.registrationLinks"/>} </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            to="/administratori"
                                            style={{
                                                paddingBottom: '6px',
                                                paddingRight: '35px'
                                            }}>
                                            <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                                        </Menu.Item>
                                        <Menu.Item
                                            as={NavLink}
                                            exact to='/komentari-i-prijedlozi'
                                            style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                            <Menu.Header><Icon name='envelope' /> Komentari i prijedlozi </Menu.Header>
                                        </Menu.Item>
                                        <FormattedMessage id="route.contact" >{
                                            (msg) => (<Menu.Item
                                                as={NavLink}
                                                exact to={msg}
                                                style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                                <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />} </Menu.Header>
                                            </Menu.Item>)}</FormattedMessage>
                                    </div>
                                }
                        {activeRole.substr(0,40) === 'Služba za zapošljavanje Kantona Sarajevo' &&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/pretraga-studenata'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }
                            >
                                <Menu.Header><Icon name='group' /> Studenti </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/komentari-i-prijedlozi'
                                style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                <Menu.Header><Icon name='envelope' /> Komentari i prijedlozi </Menu.Header>
                            </Menu.Item>
                            <FormattedMessage id="route.contact" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                    <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>
                        </div>
                        }


                        {activeRole.substr(0,12) === 'Ministarstvo'  &&
                        <div>
                            <Menu.Item
                                as={NavLink}
                                exact to='/'
                                style={ {paddingBottom:'6px'} }
                            >
                                <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                            </Menu.Item>
                            <Menu.Item
                                as={NavLink}
                                exact to='/statistika'
                                style={ {paddingBottom:'6px'} } >
                                <Menu.Header><Icon name='pie chart' /> Statistika </Menu.Header>
                            </Menu.Item>

                            <Menu.Item
                                as={NavLink}
                                exact to='/spisak-zaposlenika'
                                style={ {paddingBottom:'6px'} } >
                                <Menu.Header><Icon name='group' /> Zaposlenici </Menu.Header>
                            </Menu.Item>

                            <Menu.Item
                                as={NavLink}
                                exact to='/diplomirani-studenti'
                                style={ {paddingBottom:'6px'} }>
                                <Menu.Header><Icon name='graduation cap' /> Diplomirani studenti </Menu.Header>
                            </Menu.Item>

                            <Menu.Item
                                as={NavLink}
                                exact to='/studijski-programi'
                                style={ {paddingBottom:'6px'} }
                            >
                                <Menu.Header><Icon name='list' /> Studijski programi </Menu.Header>
                            </Menu.Item>


                            <Menu.Item as='a' style={ {paddingBottom:'6px'} }>
                                <Menu.Header   onClick= {()=>this.setState({showLookups:!this.state.showLookups})} ><Icon name='database' />  Šifrarnici <Icon  name={this.state.showLookups ? 'dropdown' : 'caret left'} size='small' style={{float:'right'}}/></Menu.Header>
                                { this.state.showLookups &&
                                <Menu.Menu style={ {marginLeft:'7px'} } >
                                    {lookupConfig.map((config, index) => (
                                        <Menu.Item as={NavLink}  exact to={'/šifrarnici/' + config.frontEndPath}
                                                   content={config.tableSimpleName}
                                        />
                                    ))}
                                </Menu.Menu>
                                }
                            </Menu.Item>

                            <Menu.Item
                                as={NavLink}
                                exact to='/komentari-i-prijedlozi'
                                style={ {paddingBottom:'6px'} }>
                                <Menu.Header><Icon name='envelope' /> Komentari i prijedlozi </Menu.Header>
                            </Menu.Item>

                            <FormattedMessage id="route.contact" >{
                                (msg) => (<Menu.Item
                                    as={NavLink}
                                    exact to={msg}
                                    style={ {paddingBottom:'6px'} } >
                                    <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />} </Menu.Header>
                                </Menu.Item>)}</FormattedMessage>

                        </div>
                        }

                        {activeRole.substr(0,2) === 'HR'  &&
                            <div>

                                <Menu.Item
                                    as={NavLink}
                                    exact to='/'
                                    style={ {paddingBottom:'6px'} }
                                >
                                    <Menu.Header> <Icon name='home' /> {<FormattedMessage id="sidebar.home" />} </Menu.Header>
                                </Menu.Item>

                                    <Menu.Item  as='a' style={ {paddingBottom:'6px', paddingRight:'35px'} }>
                                        <Menu.Header onClick= {()=>this.setState({showDocument:!this.state.showDocument})}> <Icon name='users' /> Zaposlenici <Icon  name={this.state.showDocument ? 'dropdown' : 'caret left'} style={{float:'right'}} size='small' /></Menu.Header>
                                        {this.state.showDocument &&
                                        <Menu.Menu style={{marginLeft:'7px'}}>

                                            {activeRole.substr(0,13) === 'HR admin - OJ' && <Menu.Item as={NavLink} exact to='/pretraga-i-unos-osobe'
                                                        content='Pretraga i unos osobe'
                                            />}
                                            <Menu.Item as={NavLink} exact to='/nastavno-i-naučno-istraživačko-osoblje'
                                                       content='Nastavno osoblje' onClick={()=>localStorage.setItem('osoblje', 'nastavno')}
                                            />
                                            <Menu.Item as={NavLink} exact to='/nenastavno-osoblje'
                                                       content='Nenastavno osoblje' onClick={()=>localStorage.setItem('osoblje', 'nenastavno')}
                                            />
                                            <Menu.Item as={NavLink} exact to='/angažovano-osoblje'
                                                       content='Angažovano osoblje' onClick={()=>localStorage.setItem('osoblje', 'angažovano')}
                                            />
                                        </Menu.Menu>}
                                    </Menu.Item>


                                {activeRole.substr(0, 13) !== 'HR admin - OJ' &&
                                    <Menu.Item
                                        as={NavLink}
                                        exact to='/lista-za-zaposljavanje'
                                        style={ {paddingBottom:'6px'} }
                                    >
                                        <Menu.Header><Icon name='list' />Lista za zapošljavanje </Menu.Header>
                                    </Menu.Item>
                                }




                                <Menu.Item as={NavLink}
                                           exact to='/sistematizacije'
                                           style={ {paddingBottom:'6px'} }
                                >
                                    <Menu.Header><Icon name='list alternate outline' />Sistematizacije </Menu.Header>
                                </Menu.Item>

                                <Menu.Item as={NavLink}
                                       exact to='/izvještaji'
                                       style={ {paddingBottom:'6px'} }
                                >
                                    <Menu.Header><Icon name='chart line' /> Izvještaji </Menu.Header>
                                </Menu.Item>
                                <FormattedMessage id="route.contact" >{
                                    (msg) => (<Menu.Item
                                        as={NavLink}
                                        exact to={msg}
                                        style={ {paddingBottom:'6px', paddingRight:'35px'} } >
                                        <Menu.Header><Icon name='info circle' /> {<FormattedMessage id="sidebar.contact" />}</Menu.Header>
                                    </Menu.Item>)}</FormattedMessage>
                                {/*<Menu.Item*/}
                                {/*    as={NavLink}*/}
                                {/*    exact to='/pitanja-i-odgovori'*/}
                                {/*    style={ {paddingBottom:'6px', paddingRight:'35px'} }>*/}
                                {/*    <Menu.Header><Icon name='question' />  FAQ  </Menu.Header>*/}
                                {/*</Menu.Item>*/}
                                <Menu.Item
                                    as={NavLink}
                                    to="/administratori"
                                    style={{
                                        paddingBottom: '6px',
                                        paddingRight: '35px'
                                    }}>
                                    <Menu.Header><Icon name="user outline"/> Administratori </Menu.Header>
                                </Menu.Item>

                            </div>
                        }
                            </div>}
                    </Menu>

            </div>
        );
    }
}
export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js